import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { ReactiveList, ReactiveComponent, MultiList, SearchBox } from '@appbaseio/reactivesearch';

import PlatformCards from '../components/PlatformCards';
import ApexBarChartWrapper from '../components/ApexBarChartWrapper';
import ApexDonutChartWrapper from '../components/ApexDonutChartWrapper';
import Barchart from '../charts/apex/Barchart';
import Areachart from '../charts/apex/Areachart';
import StyledCard from '../components/StyledCard';

const styles = (theme) => ({
	card: {
		border: `1px solid ${theme.palette.grey['300']}`,
		boxShadow: 'none',
		borderRadius: '2px',
	},
	title: {
		fontSize: 14,
	},
	pos: {
		marginBottom: 12,
	},
	dNone: {
		display: 'none !important',
	},
	search: {
		'& ul': {
			zIndex: '12',
		},
	},
});

function Dashboard(props) {
	const { classes } = props;
	return (
		<Grid container spacing={4}>
			<Grid item xs={12}>
				<SearchBox
					componentId="Search"
					dataField={[
						'Name',
						'Name.autosuggest',
						'Name.keyword',
						'Platform',
						'Developer',
					]}
					includeFields={['*']}
					fuzziness="AUTO"
					className={classes.search}
					highlightField={['Name']}
					enableRecentSuggestions
					enablePopularSuggestions
					enablePredictiveSuggestions
					popularSuggestionsConfig={{
						size: 3,
						minHits: 2,
						minChars: 4,
					}}
					recentSuggestionsConfig={{
						size: 3,
						minChars: 4,
					}}
					size={10}
					autosuggest
					index="dashboard-app-index"
					debounce={400}
					showClear
					showVoiceSearch
					placeholder="Try searching 'Grand Theft Auto'"
				/>
			</Grid>
			<Grid item xs={12}>
				<ReactiveComponent
					react={{
						and: ['Search'],
					}}
					componentId="Platform"
					dataField="Platform.keyword"
					defaultQuery={() => ({
						...MultiList.generateQueryOptions({
							dataField: 'Platform.keyword',
							size: 100,
						}),
					})}
					render={({ value, setQuery, aggregations }) => (
						<PlatformCards
							selectedValue={value}
							aggregations={aggregations}
							setQuery={setQuery}
							dataField="Platform.keyword"
						/>
					)}
				/>
			</Grid>
			<StyledCard sizes={{ sm: 6, xs: 12 }} title="Top Critic Games">
				<ReactiveList
					react={{ and: ['Platform', 'Search'] }}
					dataField="Critic_Score"
					componentId="dashboard_result"
					sortBy="desc"
					pagination
					innerClass={{
						pagination: classes.dNone,
						poweredBy: classes.dNone,
					}}
					showResultStats={false}
					render={({ data }) => {
						const names = [];
						const scores = [];
						const userScores = [];
						data.forEach((result) => {
							names.push(result.Name);
							scores.push(result.Critic_Score);
							userScores.push(result.User_Score * 10);
						});
						return (
							<Barchart
								id="Score"
								xAxisData={names}
								barData={[
									{ name: 'Critic Score', data: scores },
									{ name: 'User Score', data: userScores },
								]}
							/>
						);
					}}
				/>
			</StyledCard>
			<StyledCard sizes={{ sm: 6, xs: 12 }} title="Latest Games">
				<ReactiveList
					react={{ and: ['Platform', 'Search'] }}
					dataField="Year_of_Release"
					componentId="Latest Games"
					sortBy="desc"
					pagination
					innerClass={{
						pagination: classes.dNone,
						poweredBy: classes.dNone,
					}}
					showResultStats={false}
					render={({ data }) => {
						const names = [];
						const years = [];
						data.forEach((result) => {
							names.push(result.Name);
							years.push(result.Year_of_Release);
						});
						return (
							<Areachart
								xAxisData={names}
								areaData={[{ name: 'Year', data: years }]}
								id="Reles"
							/>
						);
					}}
				/>
			</StyledCard>
			<StyledCard sizes={{ sm: 6, xs: 12 }} title="All Genres">
				<ReactiveComponent
					componentId="Genre"
					react={{ and: ['Search'] }}
					defaultQuery={() => ({
						...MultiList.generateQueryOptions({
							dataField: 'Genre.keyword',
							size: 100,
							sortBy: 'asc',
						}),
					})}
					render={({ value, setQuery, aggregations }) => (
						<ApexDonutChartWrapper
							selectedValue={value}
							aggregations={aggregations}
							setQuery={setQuery}
							dataField="Genre.keyword"
						/>
					)}
				/>
			</StyledCard>
			<StyledCard sizes={{ sm: 6, xs: 12 }} title="Games Published Yearly">
				<ReactiveComponent
					componentId="Uear of Release"
					dataField="Year_of_Release"
					react={{ and: ['Search'] }}
					defaultQuery={() => ({
						...MultiList.generateQueryOptions({
							dataField: 'Year_of_Release',
							size: 100,
							sortBy: 'asc',
						}),
					})}
					render={({ value, setQuery, aggregations }) => (
						<ApexBarChartWrapper
							selectedValue={value}
							name="Games Published"
							aggregations={aggregations}
							setQuery={setQuery}
							dataField="Year_of_Release"
						/>
					)}
				/>
			</StyledCard>
		</Grid>
	);
}

export default withStyles(styles)(Dashboard);
